<template>
    <div class="row">
        <div class="col-md-12 mb-1">
            <label class="form-label">Kredi Kartı</label>
            <v-select-list :options="creditCards" v-model="value.CreditCardNumber" placeholder="Kredi Kartı"></v-select-list>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Plaka Verileri</label>
            <div class="alert alert-dark mb-0">
                <div class="alert-body">
                    <div class="row align-items-end">
                        <div class="col-md-9 mb-1 mb-md-0">
                            <label class="form-label">Plaka</label>
                            <v-select-list v-model="plate" :options="plates" label="PlateValue" placeholder="Plaka Seçiniz"></v-select-list>
                        </div>
                        <div class="col-md-3">
                            <button :disabled="!plate" v-on:click="addPlate" class="btn btn-success w-100">Ekle</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12">
            <table class="table table-bordered table-sm mb-0">
                <thead>
                    <tr>
                        <th class="w-40">Plaka</th>
                        <th class="w-60">HGS No</th>        
                        <th>İşlemler</th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(item,index) in value.PlatesOfHGSCancelApplications">
                        <tr :key="index">
                            <td>{{item.PlateNumber}}</td>
                            <td>
                                <input class="form-control form-control-sm" v-model="item.HGSNumber" type="text" placeholder="HGS No"/>
                            </td>
                            <td class="text-center">
                                <button v-on:click="$delete(value.PlatesOfHGSCancelApplications,index)" class="btn btn-flat-danger btn-sm btn-icon">
                                    <feather-icon icon="TrashIcon"></feather-icon>
                                </button>
                            </td>
                        </tr>
                    </template>
                    <tr v-if="value.PlatesOfHGSCancelApplications.length == 0">
                        <td colspan="8" class="text-center">Henüz bir plaka eklemediniz.</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import {BCard} from 'bootstrap-vue'
import VehicleOperationsApi from '@/api/vehicle-operations'
import SystemConstantParametersApi from '@/api/system-constant-parameters'

export default {
    props:{
        value:Object,
    },
    components:{
        BCard,
    },
    data(){
        return{
            plateClasses:[1,2,3,4,5],
            plate:null,
            plates:[],
            creditCards:[],
            defaultText:"",
            loading:false
        }
    },
    mounted(){
        this.getPlates()
        this.getCreditCards()
    },
    methods:{
        addPlate(){
            let data = {
                PlateNumber: this.plate.PlateValue,
                PlateId: this.plate.Id,
                HGSNumber:null
            }
            this.value.PlatesOfHGSCancelApplications.push(data)
            this.plate = null
        },
        getCreditCards(){
            SystemConstantParametersApi.GetListByCode("CREDIT_CARD").then(res=>{
                this.creditCards = res.data.Data
            })
        },
        getPlates(){
            return new Promise((resolve,reject)=>{
                VehicleOperationsApi.Plate.ListViaNotUsingWithUsingPlate(null)
                .then(response => {
                    this.plates = response.data.Data
                    resolve()
                }).catch(err=>{ reject() })
            })
        },
    },
}
</script>

<style>

</style>